<div
  [attr.data-component-id]="service.dataComponentId"
  [class.systembar-service-tab-item--disabled]="service.disabled"
  [matTooltip]="service.disabled ? ('NOVA.SYSTEM_BAR.DISABLED_SWITCH_TO_OTHER_DOMAIN' | translate: { url: service.applicationUrl }) : ''"
  (click)="clicked()">
  @let hasContextMenu = service.contextMenuItems.length > 1;
  <div
    class="systembar-service-tab-item_flex-wrapper"
    [class.systembar-service-tab-item_flex-wrapper--active]="service.active || isMenuOpen()"
    [class.systembar-service-tab-item--disabled]="service.disabled"
    [matMenuTriggerFor]="hasContextMenu ? serviceContextMenu : null"
    (menuOpened)="isMenuOpen.set(true)"
    (menuClosed)="isMenuOpen.set(false)">
    <ng-container *ngTemplateOutlet="serviceTabItem"></ng-container>
  </div>
</div>

<ng-template #serviceTabItem>
  <div class="systembar-service-tab-item_info-wrapper">
    <celum-icon
      [ngClass]="!service.interactable || service.disabled ? 'systembar-service-tab-item_celum-icon' : 'systembar-service-tab-item_celum-icon-with-pointer'"
      [configuration]="service.iconConfiguration"></celum-icon>
    <span class="systembar-service-tab-item_icon-text">{{ service.text }}</span>
  </div>
</ng-template>

@for (subService of service.subServices; track subService) {
  <systembar-sub-service-tab-item [subService]="subService" (onClick)="subServiceClicked($event)"></systembar-sub-service-tab-item>
}

<mat-menu class="celum-scrollbar" [class]="'service-tab-item_menu'" #serviceContextMenu="matMenu">
  @for (contextMenuItem of service.contextMenuItems; track contextMenuItem) {
    <button
      mat-menu-item
      class="service-tab-item_menu-item"
      spaceAwareTooltip
      (click)="contextMenuItem.onClick()"
      [attr.data-component-id]="contextMenuItem.dataComponentId"
      [matTooltip]="contextMenuItem.text | stripUrlProtocol">
      {{ contextMenuItem.text | stripUrlProtocol }}
    </button>
  }
</mat-menu>
